import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import AddIcon from '@mui/icons-material/Add';
import CustomButton from '../../../components/buttons/CustomButton';
import styles from './ProcedureEmptyState.module.css';

/** Lista vazia: ilustração leve, o que é um procedimento e o atalho para o primeiro. */
function ProcedureEmptyState({ canManage, blockedReason, onAdd }) {
    return (
        <div className={styles.empty}>
            <div className={styles.art} aria-hidden="true">
                <span className={`${styles.ghostCard} ${styles.ghostBack}`} />
                <span className={`${styles.ghostCard} ${styles.ghostFront}`}>
                    <span className={styles.ghostIcon}><MedicalServicesOutlinedIcon fontSize="small" /></span>
                    <span className={styles.ghostLines}>
                        <span className={styles.ghostLine} />
                        <span className={`${styles.ghostLine} ${styles.ghostLineShort}`} />
                    </span>
                    <span className={styles.ghostPrice}>R$</span>
                </span>
            </div>
            <span className={styles.title}>Nenhum procedimento cadastrado</span>
            <span className={styles.text}>
                Cadastre o que você oferece, com valor e duração. A agenda usa esses dados em cada horário marcado.
            </span>
            <div className={styles.action}>
                <Tooltip title={blockedReason} arrow>
                    <span>
                        <CustomButton
                            style="main"
                            variant="contained"
                            icon={<AddIcon />}
                            label="Adicionar procedimento"
                            onClick={onAdd}
                            disabled={!canManage}
                        />
                    </span>
                </Tooltip>
            </div>
        </div>
    );
}

export default ProcedureEmptyState;
